// 시안 F 메일(Roundcube elastic) 피부(#2014 f-collab · 구조는 원제품 · 색·크기만). EmbedPage 가 메일(mail2) iframe 문서에 넣는다.
// 왜 CSS 주입인가: RC 스킨은 LESS 고정값(CSS 변수 없음)이고 플러그인 CSS 길은 서버 손 배치다 — 같은 오리진 iframe 이라
//    통제 지점은 그 문서의 style 요소다(collabSkinMm·collabSkinNc 선례). RC 스킨 파일은 건드리지 않는다.
// 🔴 모든 규칙 앞에 html:not(.dark-mode) — RC 는 OS 다크를 스스로 따라 html.dark-mode 를 붙인다(안쪽 읽기 문서도 같다).
// 🔴 읽기 창은 중첩 iframe(#messagecontframe) — 안쪽 문서에 따로 넣는다(메일을 열 때마다 안쪽만 새로 뜬다 = 바깥 onLoad 가 안 불린다).
// 🔴 삭제 단추(btn-danger)는 파랗게 하지 않는다 — RC 확인 창은 삭제·버리기에 btn-primary 와 btn-danger 를 같이 준다.
// 🔴 3열 폭은 RC large 배치(html.layout-large · iframe > 1200)에서만 — normal 배치에서 RC JS 가 숨긴 폴더 열은 건드리지 않는다.
// 🔴 CSS 문자열 안에 /* */ 주석을 넣지 않는다(collabSkinMm·collabSkinNc 와 같은 규약 — 시험 해석기가 주석을 셀렉터로 읽는다).
// 선택자는 RC 1.6.16 elastic 기준 — 판 올림 때 id·클래스가 바뀌면 조용히 빠진다.
export const RC_FSKIN_STYLE_ID = 'gw-rc-fskin';
export const RC_FSKIN_READER_STYLE_ID = 'gw-rc-fskin-reader';
export const RC_READER_FRAME_ID = 'messagecontframe';
export const RC_FSKIN_LIGHT = 'html:not(.dark-mode)';

// 선택자마다 밝은 조건을 붙인다 — RC 배치 클래스(.layout-*)만 같은 <html> 의 클래스라 띄우지 않는다(html:not(.dark-mode).layout-large).
// 🔴 그 밖의 조각은 '.' 으로 시작해도(.btn-link·.btn-primary·.form-control) 자손이다 — 붙이면 <html> 에 그 클래스가 있어야 해서 아무것도 안 닿는다.
const ON_HTML = /^\.layout-/;
const h = (...sels) => sels.map((s) => RC_FSKIN_LIGHT + (ON_HTML.test(s) ? '' : ' ') + s).join(',');

const FONT = 'font-family:"Pretendard Variable",Pretendard,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif';

// 바깥 문서 — 값은 시안 F 줄 10(토큰)·22(메일 3열)·27(≤900)·28(≤600).
export const RC_FSKIN_CSS = [
  // ① 글자·주색(하늘색 → 파랑)
  h('body') + '{' + FONT + ';color:#32312e}',
  h('a', '.btn-link') + '{color:#2383e2}',
  h('.btn-primary:not(.btn-danger)', '#rcmloginsubmit')
    + '{background:#2383e2 !important;border-color:#2383e2 !important;color:#fff !important;border-radius:5px}',
  h('.btn-primary:not(.btn-danger):hover', '#rcmloginsubmit:hover')
    + '{background:#1873ce !important;border-color:#1873ce !important}',
  h('.form-control:focus') + '{border-color:#2383e2 !important;box-shadow:0 0 0 .2rem #2383e24d !important}',
  // ② 맨 왼쪽 메뉴 열 — 어두운 → 밝은(구조는 그대로 · 로그아웃 빨강은 남긴다)
  h('#layout-menu', '#layout-menu .popover-header', '#taskmenu .special-buttons') + '{background:#f7f7f5 !important}',
  h('#layout-menu') + '{border-right:1px solid #eeeeec}',
  h('#taskmenu a:not(.logout)') + '{color:#64635f !important}',
  h('#taskmenu a:not(.logout):hover', '#taskmenu a:not(.logout):focus')
    + '{background:#efefed !important;color:#32312e !important}',
  h('#taskmenu a.selected', '#taskmenu a.selected:hover') + '{background:#eaeae7 !important;color:#32312e !important}',
  // ③ 폴더 열(g2-032)
  h('#layout-sidebar') + '{background:#fbfbfa;border-right:1px solid #eeeeec}',
  h('#mailboxlist li.selected') + '{background:transparent}',
  h('#mailboxlist li a') + '{font-size:12px;line-height:33px;color:#64635f}',
  h('#mailboxlist li.selected>a') + '{background:#eaeae7;color:#32312e;font-weight:600}',
  h('#mailboxlist .unreadcount') + '{font-size:10px;background:transparent;color:#92918d}',
  // ④ 목록 열(g2-032) — 한 행 = td.subject 안 span.fromto·span.date·span.subject(widescreen) · 깃발/삭제 행 색은 RC 그대로
  h('#layout-list') + '{border-right:1px solid #eeeeec}',
  h('#messagelist tbody td') + '{font-size:12px !important;border-bottom:1px solid #eeeeec}',
  h('#messagelist tbody tr td.subject', '#messagelist tbody tr td.flags', '#messagelist tbody tr td.threads')
    + '{padding-top:14px;padding-bottom:13px}',
  h('#messagelist tbody tr td.subject') + '{padding-left:14px;padding-right:14px}',
  h('#messagelist tr:not(.flagged):not(.deleted) .fromto') + '{font-size:11px !important;color:#64635f}',
  h('#messagelist tr:not(.flagged):not(.deleted) .date') + '{font-size:10px !important;color:#92918d}',
  h('#messagelist .subject a') + '{font-weight:500}',
  // 안읽음 보낸이는 위 «깃발/삭제 아닌 행 .fromto»(회색)보다 강해야 진하게 보인다 — 같은 :not 두 개를 붙여 강도를 맞춘다
  h('#messagelist tr.unread .subject a', '#messagelist tr.unread:not(.flagged):not(.deleted) .fromto') + '{font-weight:650;color:#32312e}',
  h('#messagelist tbody tr:hover td') + '{background:#fbfbfa}',
  h('#messagelist tr.selected td') + '{background:#eaf3fc !important}',
  h('#messagelist tr.selected td:first-child') + '{box-shadow:inset 2px 0 #2383e2}',
  // 포커스 행은 배경을 바꾸지 않는다 — 포커스 표시선 색만(RC 원래 하늘색 2px)
  h('#messagelist tr.focused td:first-child') + '{box-shadow:inset 2px 0 #2383e2}',
  // ⑤ 빈 목록(g2-035) — RC 문구 그대로 · 크기·색만
  h('#layout-list .listing-info') + '{font-size:12px;color:#92918d}',
  // ⑥ 로그인 폼(g2-033) — 시안 화면은 없다 · 입력·아이콘 칸·단추를 시안 결로
  h('#login-form .input-group-text') + '{height:36px;font-size:13px}',
  h('#login-form input.form-control') + '{font-size:13px;height:36px;border-color:#e5e5e2;border-radius:0 5px 5px 0}',
  h('#login-form #rcmloginsubmit') + '{font-size:13px;height:36px}',
  // ⑦ 3열 폭(g2-032) — large 배치(iframe > 1200)에서만 · RC 열 폭 손잡이(인라인 width·flex)가 이기게 !important 없이
  h('.layout-large #layout-sidebar') + '{flex:0 0 171px;width:171px}',
  h('.layout-large #layout-list') + '{flex:0 0 320px;width:320px}',
  // ⑧ 좁은 배치(g2-034 · 시안 줄 27·28) — RC 배치 클래스에만 건다(iframe 769~900 = normal 은 기본 값)
  h('.layout-small #messagelist tbody td', '.layout-phone #messagelist tbody td') + '{font-size:14px !important}',
  h('.layout-small #messagelist tbody tr td.subject', '.layout-phone #messagelist tbody tr td.subject') + '{padding:15px 22px}',
  h('.layout-small #messagelist tr:not(.flagged):not(.deleted) .fromto',
    '.layout-phone #messagelist tr:not(.flagged):not(.deleted) .fromto') + '{font-size:12px !important}',
  h('.layout-phone #messagelist tbody td') + '{font-size:13px !important}',
].join('');

// 읽기 창 안 문서(#messagecontframe) — 제목 22px/660 · 본문 13px/1.9(시안 줄 22) · ≤600 제목 21.
export const RC_FSKIN_READER_CSS = [
  h('body') + '{' + FONT + ';color:#32312e}',
  h('#message-header h2.subject') + '{font-size:22px;line-height:1.45;letter-spacing:-.5px;font-weight:660}',
  h('#messagebody') + '{font-size:13px;line-height:1.9}',
  h('a') + '{color:#2383e2}',
  '@media (max-width:600px){',
  h('#message-header h2.subject') + '{font-size:21px}',
  '}',
].join('');

// 원제품 흔적 숨김(마스터 10-27 #2688) — 피부와 달리 밝은·다크 모두. ⋮(폴더 작업 메뉴)는 남긴다(마스터 결정).
// 주소는 visibility:hidden — ⋮ 단추 자리를 그대로 두려고(머리 줄 배치 무변경). special-buttons 는 다크 모드·정보·로그아웃 셋뿐이라 통째로 숨긴다.
export const RC_CHROME_HIDE_STYLE_ID = 'gw-rc-chrome-hide';
export const RC_CHROME_HIDE_CSS = [
  '#layout-menu .popover-header #logo{display:none !important}',
  '#layout-content > #logo,#login-footer{display:none !important}',
  '#layout-sidebar .header .header-title.username{visibility:hidden !important}',
  '#taskmenu .special-buttons{display:none !important}',
].join('');

// style 을 head 에 '1개만' 유지한다 — 폴링(50ms)+onLoad 에서 반복 호출되므로 멱등이 필수.
// 이미 있으면 새로 만들지 않고 내용이 달라졌을 때만 갱신한다(applyNcFSkin 과 같은 모양). head 가 없으면 no-op.
function upsertStyle(doc, id, css) {
  if (!doc || !doc.head) return;
  const found = doc.getElementById(id);
  if (found) {
    if (found.textContent !== css) found.textContent = css;
    return;
  }
  const st = doc.createElement('style');
  st.id = id;
  st.textContent = css;
  doc.head.appendChild(st);
}

// 다크 모드 단추를 숨겼으니 예전에 고른 colorMode 쿠키를 지운다(ui.js color_mode_init 는 쿠키를 OS 설정보다 먼저 따른다).
// 지운 뒤에는 RC 가 OS 설정을 따른다. 쿠키가 없으면 아무것도 안 한다 — 폴링마다 불려도 무해.
function clearRcColorModeOnce(doc) {
  try {
    if (!/(?:^|;\s*)colorMode=/.test(String(doc.cookie || ''))) return;
    ['/mail2/', '/mail2', '/'].forEach((p) => {
      doc.cookie = 'colorMode=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=' + p;
    });
  } catch (e) { /* 쿠키 접근 불가 — 무동작 */ }
}

function injectReader(frame) {
  try {
    upsertStyle(frame.contentDocument, RC_FSKIN_READER_STYLE_ID, RC_FSKIN_READER_CSS);
  } catch (e) { /* 이동 중·접근 불가 — 다음 load 에서 다시 넣는다 */ }
}

// ① 바깥 문서에 style#gw-rc-chrome-hide·style#gw-rc-fskin 각 1개 ② 읽기 창(#messagecontframe)이 있으면 load 리스너를 한 번만 걸고(dataset 표지)
//    지금 떠 있는 안쪽 문서에도 바로 넣는다. doc·head 가 없으면(로드 중 문서) 조용히 no-op.
// 🔴 숨김을 피부보다 먼저 넣는다 — 처음 붙일 때 피부가 head 마지막 자식이어야 한다(collabSkinRc.test 의 head 끝 계약).
// 🔴 예외를 밖으로 던지지 않는다 — EmbedPage onLoad 는 같은 try 안에서 이 뒤에 가림막 해제가 있다.
export function applyRcFSkin(doc) {
  if (!doc || !doc.head) return;
  try {
    upsertStyle(doc, RC_CHROME_HIDE_STYLE_ID, RC_CHROME_HIDE_CSS);
    clearRcColorModeOnce(doc);
    upsertStyle(doc, RC_FSKIN_STYLE_ID, RC_FSKIN_CSS);
    const f = typeof doc.getElementById === 'function' ? doc.getElementById(RC_READER_FRAME_ID) : null;
    if (!f) return;
    if (f.dataset && !f.dataset.gwSkin) {
      f.dataset.gwSkin = '1';
      f.addEventListener('load', () => injectReader(f));
    }
    injectReader(f);
  } catch (e) { /* RC DOM 변동·로드 중 — 무동작 */ }
}
